export default "__VITE_ASSET__51005aaf__"